  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries
  
  // Your web app's Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyAEhkj2xVudeCzsa9okvaThKydxSaaC2i0",
    authDomain: "centro-de-estudiantes-fcf.firebaseapp.com",
    projectId: "centro-de-estudiantes-fcf",
    storageBucket: "centro-de-estudiantes-fcf.appspot.com",
    messagingSenderId: "701699794319",
    appId: "1:701699794319:web:38ec9b3e2f86ae995697fa",
    measurementId: "G-5JE2P4W549"
  };
  
  // Initialize Firebase
 export const app = initializeApp(firebaseConfig);
